<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      <q-banner class="bg-primary text-white" inline-actions>
        فیلتر
        <template v-slot:action>
          <q-btn round flat icon="close" v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-select
          v-model="selectedCompanies"
          :options="compNames"
          option-label="CompName"
          option-value="CompID"
          label="شرکت"
          use-chips
          multiple
      />
      <q-select
          v-model="selectedStates"
          label="استان"
          :options="statesOptions"
          option-label="State_Name"
          option-value="State_ID"
          @filter="filterFn"
          use-chips
          use-input
          multiple
      />
      <q-select
          v-model="selectedCities"
          label="شهر"
          :options="citiesOptions"
          option-label="City_Name"
          option-value="City_ID"
          @filter="filterCityFn"
          use-chips
          use-input
          multiple
      />
      <q-select
          v-model="selectedGoodsGroup"
          label="گروه کالا"
          :options="goodsGroupOptions"
          option-label="Group_Name"
          option-value="Group_ID"
          @filter="filterGoodsGroupFn"
          use-chips
          use-input
          multiple
      />
      <q-select
          v-model="selectedGoods"
          label="کالا"
          :options="goodsOptions"
          option-label="Goods_Name"
          option-value="Goods_ID"
          @filter="filterGoodsFn"
          use-chips
          use-input
          multiple
      />
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "OrderTraceFilterEditor",
  emits: ['apply-filter'],
  props: {
    inputCompanies: {
      type: Array,
      default: ()=> []
    },
    inputStates: {
      type: Array,
      default: ()=> []
    },
    inputCities: {
      type: Array,
      default: ()=> []
    },
    inputGoods: {
      type: Array,
      default: ()=> []
    },
    inputGoodsGroup: {
      type: Array,
      default: ()=> []
    }
  },
  data() {
    return {
      selectedCompanies: this.inputCompanies,
      selectedStates: this.inputStates,
      selectedCities: this.inputCities,
      selectedGoods: this.inputGoods,
      selectedGoodsGroup: this.inputGoodsGroup,
      compNames: [],
      states: [],
      statesOptions: [],
      cities: [],
      citiesOptions: [],
      goods: [],
      goodsOptions: [],
      goodsGroup: [],
      goodsGroupOptions: []
    }
  },
  methods: {
    ...mapActions({
      initialize: 'Customers/getCustomerSearchConstants',
      getCities: 'Customers/getCity',
      setGoodsGroup: 'Products/getGoodsGroup',
      setGoodsList: 'Products/getGoodsList'
    }),
    filterFn(val, update) {
      update(() => {
        this.statesOptions = this.states.filter(item => item.State_Name.includes(val))
      })
    },
    filterCityFn(val, update) {
      update(() => {
        this.citiesOptions = this.cities.filter(item => item.City_Name.includes(val))
      })
    },
    filterGoodsGroupFn(val, update) {
      update(() => {
        this.goodsGroupOptions = this.goodsGroup.filter(item => item.Group_Name.includes(val))
      })
    },
    filterGoodsFn(val, update) {
      update(() => {
        this.goodsOptions = this.goods.filter(item => item.Goods_Name.includes(val))
      })
    },
  },
  watch: {
    selectedCompanies: function (val) {
      this.$emit('apply-filter', {
        selectedCompanies: val,
        selectedStates: this.selectedStates,
        selectedCities: this.selectedCities,
        selectedGoodsGroup: this.selectedGoodsGroup
      })
    },
    selectedStates: function (val) {
      if (val && val.length > 0) {
        let stateIDs = val.map(item => item.State_ID)
        this.getCities(stateIDs.join(',')).then((res) => {
          this.cities = res;
          this.citiesOptions = this.cities
        })
      } else {
        this.cities = []
        this.citiesOptions = []
      }
      this.$emit('apply-filter', {
        selectedCompanies: this.selectedCompanies,
        selectedStates: val,
        selectedCities: this.selectedCities,
        selectedGoodsGroup: this.selectedGoodsGroup,
        selectedGoods: this.selectedGoods
      })
    },
    selectedCities: function (val) {
      this.$emit('apply-filter', {
        selectedCompanies: this.selectedCompanies,
        selectedStates: this.selectedStates,
        selectedCities: val,
        selectedGoodsGroup: this.selectedGoodsGroup,
        selectedGoods: this.selectedGoods
      })
    },
    selectedGoodsGroup: function (val) {
      if (val && val.length > 0) {
        this.setGoodsList(val).then((res) => {
          this.goods = res;
          this.goodsOptions = this.goods;
        })
      }

      this.$emit('apply-filter', {
        selectedCompanies: this.selectedCompanies,
        selectedStates: this.selectedStates,
        selectedCities: this.selectedCities,
        selectedGoodsGroup: val,
        selectedGoods: this.selectedGoods
      })
    },
    selectedGoods: function (val) {
      this.$emit('apply-filter', {
        selectedCompanies: this.selectedCompanies,
        selectedStates: this.selectedStates,
        selectedCities: this.selectedCities,
        selectedGoodsGroup: this.selectedGoodsGroup,
        selectedGoods: val
      })
    }
  },
  created() {
    this.selectedCompanies = this.inputCompanies
    this.selectedStates = this.inputStates
    this.selectedCities = this.inputCities
    this.selectedGoodsGroup = this.inputGoodsGroup
    this.selectedGoods = this.inputGoods

    this.initialize().then((res) => {
      this.compNames = eval(res.company)
      this.states = eval(res.customerState)
      this.statesOptions = this.states

      this.setGoodsGroup().then((res) => {
        this.goodsGroup = res
        this.goodsGroupOptions = this.goodsGroup
      })
    })
  }
}
</script>

<style scoped>

</style>